export default {
    sharedMonitors: [],
    loading: false,
    selectedMonitor: null,
    selectMonitor: () => {},
    isOpenInfo: false,
    setIsOpenInfo: () => {},
};
